import React, {Component} from 'react';
import {withRouter, Route} from 'react-router-dom';
import {connect} from 'react-redux';

// styles
import style from '../../Styles/Containers/Photo.module.css'

class VideoPlayer extends Component{

  constructor(){
    super();
    this.state = {
    }
  }
  render(){
    return(
      <div className={style.container} style={{height: window.innerHeight}}>
          <img src={"https://d15eixcc3515pq.cloudfront.net/Assets/img/ic-delete.svg"} className={style.icon} 
            style={{position: "absolute", right: 16, top: 16}}></img>
          <div className={style.videoArea} >
            <img src={"https://d15eixcc3515pq.cloudfront.net/Assets/img/ic-play.svg"} className={style.playButton}></img>
          </div>
      </div>
      
    )
  }

}

export default connect()(withRouter(VideoPlayer))
